<template>
    <div class="banner-area">
      <div class="text-center">
        <img :src="require('@/assets/img/bg/smaco-10.jpg')" alt="img" style="width: 50%;">
      </div>
    </div>
  </template>

<script>
    export default {
        name: "Banner",
    }
</script>


// WEBPACK FOOTER //
// src/components/page/service/Banner.vue